import { render, staticRenderFns } from "./LangSelector.vue?vue&type=template&id=b516d14c&scoped=true&"
import script from "./LangSelector.vue?vue&type=script&lang=js&"
export * from "./LangSelector.vue?vue&type=script&lang=js&"
import style0 from "./LangSelector.vue?vue&type=style&index=0&id=b516d14c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b516d14c",
  null
  
)

export default component.exports